import React, { createRef } from "react";
import {
    Select,
    Image,
    Button,
    DatePicker,
    Space,
    Row,
    Col,
    Checkbox,
    Dropdown,
    Modal,
    Form,
    Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import DriverScoreReportStore from "../store/DriverScoreReportStore";
import DriverLoginReportStore from "../store/DriverLoginReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import VehicleStore from "../store/VehicleStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";
import BrushSweeperReportStore from "../store/BrushSweeperReportStore";

const { RangePicker } = DatePicker;
const { Option } = Select;
let widthAdderFunc = (arr) => {
    let array = arr;
    array.map((val) => {
        if (val.title?.length > 24) {
            val.width = 250;
        } else if (val.title?.length > 15) {
            val.width = 200;
        } else if (val.title?.length > 12) {
            val.width = 150;
        } else if (val.title?.length > 8) {
            val.width = 125;
        } else {
            val.width = 110;
        }
        // console.log(val.title.length)
    });

    return arr;
};

class BrushSweeperReport extends React.Component {
    constructor(props, context) {
        super(props);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.driverScoreReportStore = new DriverScoreReportStore();
        this.driverLoginReportStore = new DriverLoginReportStore();
        this.vehicleStore = new VehicleStore();
        this.brushSweeperReport = new BrushSweeperReportStore()
        this.pythonMessageRef = createRef();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            selectedDriver: [],
            selectedVehicle: [],
            selectAllDrivers: false,
            selectAllVehicles: false,
            companyId: "",
            pageNo: 1,
            offset: 0,
            limit: 50,
            modalVisible: false,
            column: "",
            filter: "",
            dateWiseReport: false,
            // fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            // toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),

            Notcompany: false,
            Notdriver: false,
            Notdate: false,
            Nottype: false,
            NotFilter: false,
            filterby: "",
            notvehicle: false,
            reportmessage: "",

            selectedColumns: widthAdderFunc([
                {
                    // title: "Driver",
                    title: context.translate("_VEHICLE_NO_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: "15%",
                },
                {
                    // title: "Asset",
                    title: context.translate("_STARTTIME_"),
                    dataIndex: "startTime",
                    key: "startTime",
                    width: "15%",
                },
                {
                    // title: "Date",
                    title: context.translate("_STOPTIME_"),
                    dataIndex: "stopTime",
                    key: "stopTime",
                    width: "15%",
                },
                {
                    // title: "Date",
                    title: context.translate("_LEFT_SWEEPER_USAGE_"),
                    dataIndex: "leftSweeperUsage",
                    key: "leftSweeperUsage",
                    width: "15%",
                },
                {
                    // title: "Date",
                    title: context.translate("_RIGHT_SWEEPER_USAGE_"),
                    dataIndex: "rightSweeperUsage",
                    key: "rightSweeperUsage",
                    width: "15%",
                },
                {
                    // title: "Date",
                    title: context.translate("_TOTAL_SWEEPER_USAGE_"),
                    dataIndex: "totalSweeperUsage",
                    key: "totalSweeperUsage",
                    width: "15%",
                },
            ])
        };
        this.newColumns = [...this.state.selectedColumns];
    }
    async componentDidMount() {
        this.setState({ pageSize: 50 });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            await this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ companyId: comp?.value });
        await this.setState({ selectedVehicle: [], selectAllVehicles: false });

        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        await this.handleSearch();
    }

    async handleSearch() {

        await this.setState({ loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        await this.setState({
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }

    checkFromDate(dates) {
        //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }

    addMonths = (date, months) => {
        // date.setMonth(date.getMonth() + months);
        // date = date + months;
        var indx = dayjs().month() + -6;
        // return date.format("YYYY-MM-DD HH:mm:ss");
        return dayjs().month(indx);
    };


    showData = async () => {
        console.log("first", this.state.companyId)
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.fromDate) {
            this.setState({ Notdate: true });
        } else {
            this.setState({ Notdate: false });
        }
        if (
            this.state.companyId &&
            this.state.fromDate &&
            this.state.toDate
        ) {
            this.setState({
                Notcompany: false,
                notvehicle: false,
            });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.brushSweeperReport.loadData({
                    offset: (this.state.pageNo - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    vehicleId: this.state.selectedVehicle,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    pageNo: this.state.pageNo,
                });
            }
            await this.setState({ loadData: 1 });
        }
    };

    handleCheckboxChange = async (column) => {

        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );

            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {

            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };




    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" })
        }
    };

    refreshList = async () => {
        await this.setState({ loading: false, current: 1, currentPage: 1 });
        await this.showData();
    };
    triggerReport = () => {
        this.pythonMessageRef.current.show(); // show the modal
    };
    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    onChange={this.handleChange}
                                    className="searchInput"
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                {this.props.getUserData().isadmin === 1 && (
                                    <DeviceGroupsForVehicles
                                        vehicleStore={this.vehicleStore}
                                        setLoadDta={() => this.setState({ loadData: 1 })}
                                        resetVehicles={() =>
                                            this.setState({
                                                selectedVehicle: [],
                                                selectAllVehicles: false,
                                            })
                                        }
                                    />
                                )}

                                <Select
                                    // maxTagCount="responsive"
                                    className="searchInput"
                                    value={this.state.selectedVehicle}
                                    onChange={(val) => {
                                        this.setState({
                                            selectedVehicle: val,
                                            notvehicle: false,
                                        });
                                        if (
                                            this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllVehicles: false });
                                        } else {
                                            this.setState({ selectAllVehicles: true });
                                        }
                                    }}
                                    style={{ width: 200 }}
                                    showSearch
                                    status={this.state.notvehicle ? "error" : false}
                                    // mode="multiple"
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                                        (val) => {
                                            return (
                                                <Option value={val.vehicleId}>
                                                    {val.vehicleNo}
                                                </Option>
                                            );
                                        }
                                    )}
                                </Select>

                                <RangePicker
                                    placeholder={[
                                        this.context.translate("_FROM_DATE_TIME_"),
                                        this.context.translate("_TO_DATETIME_"),
                                    ]}
                                    rules={[
                                        { required: true, message: "Please select a date range" },
                                    ]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    // disabledDate={(current) => {
                                    //   return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [
                                            dayjs().startOf("day"),
                                            dayjs().endOf("day"),
                                        ],
                                    }}
                                    status={this.state.Notdate ? "error" : false}
                                    defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                                />

                                <Button
                                    type="primary"
                                    onClick={() => {
                                        this.showData();
                                        this.setState({ pageNo: 1 });
                                    }}
                                >

                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>

                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.driverScoreReportStore?.driverScoreReport?.length > 0
                                            ? false
                                            : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.pageNo}
                        pageSize={this.state.pageSize}
                        total={this.brushSweeperReport?.total}
                        columns={this.state.column}
                        dataSource={this.brushSweeperReport?.dataArray}
                        loading={this.brushSweeperReport?.loading}
                        onChange={this.handleTableChange}
                    />

                    <Modal
                        open={this.state.showEmail}
                        // title="Send Email"
                        title={this.context.translate("_SEND_EMAIL_")}
                        onOk={() => this.setState({ showEmail: false })}
                        onCancel={() => this.setState({ showEmail: false })}
                        footer={false}
                        width={400}
                    >
                        <Form
                            name="Email"
                            layout="vertical"
                            onFinish={this.onEmailSend}
                            style={{ maxWidth: "100%" }}
                        >
                            <Row>
                                <Col span={12}></Col>
                                <Col
                                    span={12}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "end",
                                    }}
                                ></Col>
                            </Row>
                            <Form.Item
                                name="Email"
                                // label="Email"
                                title={this.context.translate("_FLEET_LOGIN_EMAILLBL_")}
                                rules={[{ required: true }]}
                            >
                                <Select
                                    onSearch={this.handleSearch}
                                    fieldNames={{ label: "emailIds", value: "emailIds" }}
                                    // placeholder="Email Ids"
                                    placeholder={this.context.translate("_EMAIL_IDS_")}
                                    optionFilterProp="children"
                                    options={this.machineryReportStore?.emailIdsList}
                                    style={{ width: 355 }}
                                />
                            </Form.Item>
                            <div className="formBtnGroup">


                                <Button
                                    type="primary"
                                    className="formSaveButton"
                                    htmlType="submit"

                                >

                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>

                        </Form>
                    </Modal>
                </div>
                {
                    <div>
                        <PythonMessageAlert
                            ref={this.pythonMessageRef}
                            message={this.state.reportmessage}
                        />
                    </div>
                }
            </>
        );
    }
}
BrushSweeperReport.contextType = StoreContext;
export default observer(withRouter(BrushSweeperReport));
